import { useNavigate } from 'react-router-dom';
import { Container, Stack, Button, Box } from '@mantine/core';
import { Title, Text } from '../components/ui';
import { IconLock } from '@tabler/icons-react';
import { FadeIn } from '../components/animations';
import MainLayout from '../layouts/MainLayout';
import { useEnrichedAuth } from '../hooks/useEnrichedAuth';

export default function AccessDenied() {
  const navigate = useNavigate();
  const { user } = useEnrichedAuth();

  return (
    <MainLayout showSidebar={false}>
      <Container size="md" py="xl">
        <FadeIn delay={200}>
          <Stack align="center" gap="xl" style={{ minHeight: 'calc(100vh - 200px)', justifyContent: 'center' }}>
            <Box
              style={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                background: 'var(--mantine-color-red-1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconLock size={60} color="var(--mantine-color-red-6)" />
            </Box>

            <Stack align="center" gap="sm">
              <Title order={1}>Access Denied</Title>
              <Text size="lg" c="dimmed" ta="center" maw={500}>
                You don't have permission to access this page.
              </Text>
            </Stack>

            <Stack gap="xs" align="center">
              <Text size="sm" c="dimmed">
                Current user: <strong>{user?.email || 'Unknown'}</strong>
              </Text>
              <Text size="sm" c="dimmed">
                Your roles: <strong>{user?.roles?.join(', ') || 'None'}</strong>
              </Text>
            </Stack>

            <Button onClick={() => navigate('/')} size="lg">
              Go to Homepage
            </Button>
          </Stack>
        </FadeIn>
      </Container>
    </MainLayout>
  );
}
